export const clearResponse = () => dispatch => {
  dispatch({ type: 'CLEAR_RESPONSE', payload: null })
}
